module.exports = __webpack_public_path__ + "static/media/jawa.053c74b7.svg";